export async function uploadBlockPreview(fetch, blob, params) {
  const data = new FormData()
  data.append('file', blob, 'preview.png')

  const response = await fetch({
    headers: { 'Content-Type': undefined },
    method: 'POST',
    url: '/cms-builder/block/image',
    data,
    params,
  })

  return { key: response.key, url: response.location }
}
